<template>
  <PageWrapper :isLoading="isLoading">
    <template #title> پکیج های خرید سوال مسابقات </template>
    <template #titleBtn>
      <BButton variant="success" @click="renderCreateNewQuestionPackageDialog">
        ساخت پکیج جدید
      </BButton>
    </template>
    <CustomTable
      v-if="matchQuestionsPackageList"
      :pageNumber="getAllMatchQuestionPackFilters.pageNumber"
      :count="getAllMatchQuestionPackFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="matchQuestionsPackageList"
      @changePage="changePage"
    >
      <template #cost="data">
        {{ Intl.NumberFormat("en-US").format(data.item.cost) }} تومان
      </template>
      <template #questionCount="data">
        {{ data.item.questionCount }} سوال
      </template>
      <template #actions="data">
        <BButton
          size="sm"
          variant="transparent"
          @click="renderQuestionPackageUpdateDialog(data.item)"
        >
          <FeatherIcon
            icon="EditIcon"
            size="23"
            class="text-info"
          ></FeatherIcon>
        </BButton>
        <BButton
          size="sm"
          variant="transparent"
          @click="renderQuestionPackageDeleteConfirmationDialog(data.item)"
        >
          <FeatherIcon
            icon="Trash2Icon"
            size="23"
            class="text-danger"
          ></FeatherIcon>
        </BButton>
      </template>
    </CustomTable>
    <CreateNewQuestionPackageDialog
      @refetch="getAllMatchQuestionPackages"
    ></CreateNewQuestionPackageDialog>
    <UpdateMatchQuestionPackageDialog
      :defaulQuestionPackageDetails="tempSelectedPackage"
      @refetch="getAllMatchQuestionPackages"
    ></UpdateMatchQuestionPackageDialog>
    <DeleteQuestionPackageConfirmationDialog
      :selectedPackage="tempSelectedPackage"
      @refetch="getAllMatchQuestionPackages"
    ></DeleteQuestionPackageConfirmationDialog>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.getAllMatchQuestionPackages();
  },
  data() {
    return {
      isLoading: false,
      matchQuestionsPackageList: null,
      totalCount: null,
      tempSelectedPackage: null,
      getAllMatchQuestionPackFilters: {
        pageNumber: 1,
        count: 10,
      },
      tableColumns: [
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "name",
          label: "نام پکیج",
        },
        {
          key: "questionCount",
          label: "تعداد سوالات",
        },
        {
          key: "expireDate",
          label: "تاریخ انقضای پکیج ",
          formatter: (val) => new Date(val).toLocaleDateString("fa-IR"),
        },
        {
          key: "cost",
          label: "قیمت پکیج",
        },
        {
          key: "createAt",
          label: "تاریخ ایجاد",
          formatter: (val) => new Date(val).toLocaleDateString("fa-IR"),
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
    };
  },
  methods: {
    changePage(pageNumber) {
      this.getAllMatchQuestionPackFilters.pageNumber = pageNumber;
      this.getAllMatchQuestionPackages();
    },
    renderQuestionPackageUpdateDialog(selectedPackage) {
      this.tempSelectedPackage = JSON.parse(JSON.stringify(selectedPackage));
      this.$bvModal.show("update-question-package-dialog");
    },
    renderQuestionPackageDeleteConfirmationDialog(selectedPackage) {
      this.tempSelectedPackage = selectedPackage;
      this.$bvModal.show("delete-question-package-confirmation-dialog");
    },
    renderCreateNewQuestionPackageDialog() {
      this.$bvModal.show("create-match-question-package-dialog");
    },
    async getAllMatchQuestionPackages() {
      try {
        this.isLoading = true;
        const _this = this;
        const getAllMatchQuestionPackages = new GetAllMatchQuestionPackages(
          _this
        );
        getAllMatchQuestionPackages.setRequestParamDataObj(
          _this.getAllMatchQuestionPackFilters
        );
        await getAllMatchQuestionPackages.fetch((res) => {
          _this.matchQuestionsPackageList = res.data.data;
          _this.totalCount = res.data.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    PageWrapper,
    CustomTable,
    CreateNewQuestionPackageDialog,
    UpdateMatchQuestionPackageDialog,
    DeleteQuestionPackageConfirmationDialog,
    BButton,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import CreateNewQuestionPackageDialog from "@/views/components/MatchQuestionPackage/CreateNewQuestionPackageDialog.vue";
import UpdateMatchQuestionPackageDialog from "@/views/components/MatchQuestionPackage/UpdateMatchQuestionPackageDialog.vue";
import DeleteQuestionPackageConfirmationDialog from "@/views/components/MatchQuestionPackage/DeleteQuestionPackageConfirmationDialog.vue";
import { BButton } from "bootstrap-vue";
import { GetAllMatchQuestionPackages } from "@/libs/Api/Matches";
</script>
